import rolesCommitTypes from './commit-types';
import ReducerUtilities from "../../../shared/store/reducer-utilities";

const INITIAL_ROLES_STATE = {
  list: [],
  isLoading: []
};

function rolesReducers(state = INITIAL_ROLES_STATE, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {

    case rolesCommitTypes.SET_ROLES:
      return {
        ...state,
        list: action.roles
      };

    case rolesCommitTypes.SET_ROLES_IS_LOADING:
      return {
        ...state,
        isLoading: ReducerUtilities.updateIsLoading(
          action.isLoading,
          state.isLoading,
        ),
      };

    default:
      return state;
  }
}

export default rolesReducers;